module.exports = __webpack_public_path__ + "img/pb3.e5a4f6d9.png";